<section class="popup-page">
  <header>
    <button type="button" class="icon-button" (click)="back()" [attr.aria-label]="'PROFILE_POPUP_BACK' | translate">&#8249;</button>
    <div class="title">
      <span class="user-name">{{ userName }}</span>
      <h2>{{ 'PROFILE_POPUP_ADD_ACCESS' | translate }}</h2>
    </div>
    <button type="button" class="icon-button" (click)="close()" [attr.aria-label]="'CLOSE' | translate">&#215;</button>
  </header>
  <h3>{{ 'ASSIGN_ACCESS' | translate }}</h3>
  <div class="unit-details">
    <span class="unit-label" [title]="unit?.label || ''">{{ unit?.label }}</span>
    <span class="location-label" [title]="locationLabel">{{ locationLabel }}</span>
  </div>
  <div class="building-list" role="group" [attr.aria-label]="unit?.label" [attr.aria-busy]="isLoading">
    <p *ngIf="isLoading" class="empty" role="status">{{ 'PROFILE_POPUP_LOADING_LOCKS' | translate }}</p>
    <p *ngIf="!isLoading && !loadFailed && !locks.length" class="empty" role="status">{{ 'NO_LOCKS_PRESENT' | translate }}</p>
    <button *ngIf="loadFailed" type="button" class="building" (click)="loadLocks()">{{ 'RETRY_TEXT' | translate }}</button>
    <button
      *ngFor="let lock of locks"
      type="button"
      class="building lock-card"
      role="checkbox"
      [class.selected]="isSelected(lock)"
      [attr.aria-checked]="isSelected(lock)"
      [disabled]="isLoading || loadFailed || !lock.deviceId"
      (click)="toggleLock(lock)"
    >
      <span class="building-icon" aria-hidden="true">
        <img src="assets/svg/ico-lock-user-access.svg" alt="" />
      </span>
      <span class="building-name" [title]="lock.deviceName || ''">{{ lock.deviceName }}</span>
      <span class="selection-indicator" aria-hidden="true">
        <svg *ngIf="isSelected(lock)" viewBox="0 0 24 24" focusable="false">
          <path d="M6 12l4 4 8-9" />
        </svg>
      </span>
    </button>
  </div>
  <button type="button" class="primary-button" [disabled]="!canContinue" (click)="continue()">
    {{ 'CONTINUE' | translate }}
  </button>
</section>